import { PessoaService } from '../../pessoa.service';
import { Estudantil } from './../estudantil';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { SYSCONF_SIGLA } from 'src/app.api';
@Component({
	selector: 'app-estudantil-detail',
  	templateUrl: './estudantilDetail.component.html',
  	styleUrls: ['./estudantilDetail.component.scss']
})

export class EstudantilDetailComponent implements OnInit{
	@ViewChild('Swal') public swal:SwalComponent; 
	public message:string = '';
	detailForm: FormGroup;
	estudantil: Estudantil;
	estudantil_id: number;
	thumb:string = '';
	pessoa_id:number;
	enderecos:object = new Array();
	telefones:object = new Array();
	contasBancarias:object = new Array();
	sigla = SYSCONF_SIGLA;
	anexos: any;
	acesso = new Array();
	constructor(private pessoaService: PessoaService, private activatedRoute: ActivatedRoute,private formBuilder: FormBuilder){
		this.detailForm = this.formBuilder.group({
			id: this.formBuilder.control(0),
			dt_cadastro: this.formBuilder.control(''),
			dt_atualizacao: this.formBuilder.control(''),
			cnpj: this.formBuilder.control(''),
			razao_social: this.formBuilder.control(''),
			nome_completo: this.formBuilder.control(''),
			email: this.formBuilder.control(''),
			status: this.formBuilder.control(''),
			federacao_id: this.formBuilder.control(''),
			sigla: this.formBuilder.control(''),
			federado: this.formBuilder.control(''),
			observacao: this.formBuilder.control(''),
			website: this.formBuilder.control(''),
			foto: this.formBuilder.control('')
		});	
		this.estudantil_id = this.activatedRoute.snapshot.params['id'];
		this.pessoaService.getPessoaById('pessoa/estudantil',this.estudantil_id).subscribe(
		(estudantil) => {
			this.estudantil = estudantil.dados;
			this.pessoa_id = this.estudantil.pessoa_id;
			this.acesso = this.estudantil.acesso;
			if(this.estudantil.foto){
				this.thumb = this.estudantil.foto.thumb;
			}
			this.pessoaService.getPessoaById('pessoa',this.pessoa_id).subscribe(
				(success) =>{
					this.enderecos = success.dados.endereco;
					this.telefones = success.dados.telefone;
					this.contasBancarias = success.dados.conta_bancaria;
					this.anexos = success.dados.anexo;
				},
				(error) => {
					this.message = error.error.message;
				})
				this.detailForm.patchValue({
					id: this.estudantil.id,
					dt_cadastro: this.estudantil.dt_cadastro_br,
					dt_atualizacao: this.estudantil.dt_atualizacao_br,
					cnpj: this.estudantil.cnpj,
					razao_social: this.estudantil.razao_social,
					nome_completo: this.estudantil.nome_completo,
					email: this.estudantil.email,
					status: this.estudantil.status,
					federacao_id: this.estudantil.federacao_id,
					sigla: this.estudantil.sigla,
					federado: this.estudantil.federado == 'S' ? 'S' : 'N',
					observacao: this.estudantil.observacao,
					website: this.estudantil.website,
					foto: this.thumb
				});
			})
		}

	ngOnInit(){
		let t = JSON.parse(localStorage.getItem('CONFLogin'));
		if(!t.permissao.pessoa_estudantil.includes("CONSULTAR"))
			this.message = 'Você não possui permissão para executar esta ação'
	}
	
	
}